import { isNotEmpty } from './isNotEmpty';
import { returnIf } from './returnIf';

export function returnIfNotEmpty(input, defaultValue) {
  return returnIf(isNotEmpty, input) ?? defaultValue;
}
